<template>
  <div>
    <v-form ref="form" v-model="valid">
      <v-list three-line subheader>
        <v-subheader class="mb-3">You can leave a message using the contact form below.</v-subheader>
        <v-list-item>
          <v-text-field
            v-model="email"
            large
            label="Email"
            placeholder=" "
            outlined
            :rules="emailRules"
            @keydown.enter.prevent="emailReady"
            type="email"
          ></v-text-field>
        </v-list-item>
        <v-list-item>
          <v-textarea
            v-model="text"
            outlined
            label="Your question"
            placeholder=" "
            :rules="textRules"
            ref="text"
          ></v-textarea>
        </v-list-item>
      </v-list>
    </v-form>
    <v-list-item class="mb-10">
      <v-btn
        color="green"
        fab absolute
        top
        right
        dark
        @click="sendForm"
      >
        <v-icon>mdi-send</v-icon>
      </v-btn>
    </v-list-item>
    <v-overlay :value="snackbar">
      <v-snackbar
        v-model="snackbar"
        timeout="5000"
        color="green"
        shaped
        centered
      >
        Thank you for writing to us, a FiXpert will get in touch as soon as possible. For urgent inquiries click the telephone number listed above to talk to one of our staff members.
      </v-snackbar>
    </v-overlay>
  </div>
</template>

<script>
export default {
  data () {
    return {
      snackbar: false,
      email: '',
      text: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
      ],
      textRules: [
        v => !!v || 'Text is required.',
        v => !v || v?.length < 360 || 'Text is too long.'
      ],
      valid: true
    }
  },
  methods: {
    sendForm () {
      this.$refs.form.validate()
      if (!this.valid) return

      this.$store.dispatch('createInquiry', {
        email: this.email,
        text: this.text
      })

      this.snackbar = true
      this.email = ''
      this.text = ''
      this.$refs.form.reset()
    }
  }
}
</script>
